import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@/authConfig';
import logo from '@/assets/Logo.png';

function Login(): React.ReactElement {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-violet-600 via-purple-600 to-pink-500 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo and Title */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 mx-auto mb-6">
              <img src={logo} alt="SocialSpark" className="w-full h-full object-cover rounded-full" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">SocialSpark</h1>
            <p className="text-white/80 text-sm">Admin Dashboard</p>
          </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Welcome Back</h2>
          <p className="text-gray-600 text-sm mb-8">Sign in with your organization account to continue.</p>

          <button
            onClick={handleLogin}
            disabled={isLoading}
            className="w-full bg-gradient-to-r from-violet-600 to-pink-500 hover:from-violet-700 hover:to-pink-600 disabled:from-gray-400 disabled:to-gray-400 text-white font-semibold py-3 rounded-lg transition-all duration-200 flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <>
                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Signing in...
              </>
            ) : (
              <>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.54 12a3.54 3.54 0 100-7.08 3.54 3.54 0 000 7.08zM7 21h9c2 0 3-1 3-3v-4c0-2-1-3-3-3H7c-2 0-3 1-3 3v4c0 2 1 3 3 3z"/>
                </svg>
                Sign in with Microsoft
              </>
            )}
          </button>

          <p className="text-center text-gray-600 text-xs mt-6">
            This is a secure internal application. You must have an organization account to access.
          </p>
        </div>

        {/* Footer */}
        <p className="text-center text-white/60 text-xs mt-8">
          © 2026 SocialSpark. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Login;
